<template>
  <modal v-if="allNotifications.length && loaded" width="600px" :scrollY="false">
    <div class="slider-item p-5" v-for="(notification, i) in allNotifications" :key="i" v-show="activeIndex == i">
      <div class="flex items-center text-center">
        <div class="w-full"><h3>{{ notification.data.subject }}</h3></div>
      </div>
      <div class="w-full pt-3 leading-normal text-center" v-html="notification.data.description"></div>
      <div class="mx-auto my-6 p-1 text-white text-center w-24 h-24 rounded" v-if="notification.data.call_to_action_icon" :class="notification.data.call_to_action_icon_color">
        <!-- <i class="text-5xl p-2" :class="'fa fa-'+notification.data.call_to_action_icon"></i> -->
        <icon :name="notification.data.call_to_action_icon" />
      </div>
      <div class="w-1/2 m-auto text-sm cursor-pointer mt-6 bg-secondary p-3 text-center" v-if="notification.data.call_to_action_text" v-html="notification.data.call_to_action_text" @click="clickNotification(notification.data.call_to_action_link)"></div>
      <div class="w-full text-center m-auto text-sm cursor-pointer p-3 mt-3 mb-0 border-t border-black" @click="dismissAlerts">
        <p>Got it, Thanks</p>
        <small>This will dismiss all Network Alerts</small>
        </div>
    </div>
    <div class="flex items-center text-center justify-center">
      <span class="p-2" v-for="(notification, i) in allNotifications" :key="i" :class="[ i == activeIndex ? 'text-secondary' : 'text-grey-light' ]" @click="activeIndex = i">
        <i class="fas fa-circle"></i>
      </span>
    </div>
  </modal>
</template>

<script>
import api from '@/http'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'NetworkAlertsPopup',
  data () {
    return {
      activeIndex: 0,
      networkNotifications: [],
      automatedReferralNotifications: [],
      networkNotificationsLoaded: false,
      automatedReferralNotificationsLoaded: false
    }
  },
  computed: {
    ...mapState(['system', 'profile', 'notifications', 'selectedOffice']),
    loaded () {
      return this.networkNotificationsLoaded && this.automatedReferralNotificationsLoaded
    },
    allNotifications () {
      return this.networkNotifications.concat(this.automatedReferralNotifications)
    }
  },
  watch: {
    profile () {
      this.fetchAllNotifications()
    },
    selectedOffice () {
      this.fetchAllNotifications()
    }
  },
  methods: {
    ...mapActions(['fetchNotifications']),
    clickNotification (link) {
      if (link.startsWith('http')) {
        let tab = window.open()
        tab.location.href = link
        return
      }
      this.$router.replace(link)
    },
    dismissAlerts () {
      this.dismissNetworkAlerts()
      this.automatedReferralNotifications = []
    },
    dismissNetworkAlerts () {
      sessionStorage.setItem('hideNetworkAlertsPopup', moment().unix())
      this.networkNotifications = []
    },
    fetchAllNotifications () {
      this.networkNotificationsLoaded = false
      this.automatedReferralNotificationsLoaded = false
      this.fetchNetworkNotifications()
      this.fetchAutomatedReferralNotifications()
    },
    fetchNetworkNotifications () {
      this.fetchNotifications().then(() => {
        this.networkNotifications = this.notifications.filter(n => n.data.show_as_popup && n.data.show_as_popup === true)
          .filter(notification => notification.notifiable_id === this.selectedOffice.network_id)
          .filter(this.filterAvailableDates)
        if (sessionStorage.getItem('hideNetworkAlertsPopup')) {
          this.networkNotifications = this.networkNotifications.filter(n => moment(n.updated_at, 'YYYY-MM-DD HH:mm:ss').unix() > sessionStorage.getItem('hideNetworkAlertsPopup'))
        }
        this.networkNotificationsLoaded = true
      })
    },
    fetchAutomatedReferralNotifications () {
      if (!this.selectedOffice.id) {
        return
      }

      return api.get('automated-referral-notifcations', {
        params: {
          office_id: this.selectedOffice.id
        }
      }).then((response) => {
        this.automatedReferralNotifications = response.data
        this.automatedReferralNotificationsLoaded = true
      })
    },
    filterAvailableDates (value) {
      let nowStamp = moment().unix()
      if (value.data) {
        if (value.data.start_at && value.data.expires_at) {
          let startDate = moment(value.data.start_at, 'YYYY-MM-DD HH:mm:ss').unix()
          let endDate = moment(value.data.expires_at, 'YYYY-MM-DD HH:mm:ss').unix()
          return startDate < nowStamp && nowStamp < endDate
        } else if (value.data.start_at) {
          let startDate = moment(value.data.start_at, 'YYYY-MM-DD HH:mm:ss').unix()
          return startDate < nowStamp
        } else if (value.data.expires_at) {
          let endDate = moment(value.data.expires_at, 'YYYY-MM-DD HH:mm:ss').unix()
          return nowStamp < endDate
        }
      }

      return true
    }
  }
}
</script>
